import React from 'react';
import './Map.Widget.css';
import { MapContainer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import MapCustomLayerControl from 'Utils/Maps/Map.CustomLayerControl';
import ToStation, { CustomZoomControll } from 'Utils/Maps/ToStation';

type MapProfileWidgetProps = {
  lat: number
  lng: number
  stationIDX: string
  stationName: string
  onDragCoords?: (coords: L.LatLngTuple) => void
  style: React.CSSProperties | undefined
}

function MapProfileWidget({ lat, lng, stationIDX, stationName, onDragCoords = undefined, ...style }: MapProfileWidgetProps) {
  const defaultCoordinates: L.LatLngTuple = [55.7507, 37.6230];
  const stationPosition: L.LatLngTuple = [lat, lng];

  const icon = React.useMemo(() => L.divIcon({
    html: `
      <svg  
         id="Layer_1" 
         xmlns="http://www.w3.org/2000/svg" 
         viewBox="0 0 16 16" 
         xml:space="preserve"
         fill="#3b82f6">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.46,0C5.42,0,2.95,2.39,2.95,5.33C2.95,8.28,8.46,16,8.46,16 \t\t\ts5.51-7.72,5.51-10.67C13.96,2.39,11.5,0,8.46,0z M8.46,8c-1.38,0-2.5-1.12-2.5-2.5c0-1.38,1.12-2.5,2.5-2.5 \t\t\tc1.38,0,2.5,1.12,2.5,2.5C10.96,6.88,9.84,8,8.46,8z"/>
      </svg>`,
    className: '',
    iconSize: [32, 32],
    iconAnchor: [16, 32],
  }), []);

  const eventHandlers = React.useMemo(
    () => ({
      dragend(e: L.LeafletEvent) {
        if (onDragCoords) {
          const coords = e.target.getLatLng() as L.LatLng;
          onDragCoords([coords.lat, coords.lng]);
        }
      },
    }),
    [onDragCoords],
  );

  return (
    <div className="maps" {...style}>
      <MapContainer
        center={stationPosition || defaultCoordinates}
        zoom={12}
        minZoom={5}
        maxZoom={18}
        attributionControl={false}
        zoomControl={false}
        zoomAnimation={false}
      >
        <Marker
          icon={icon}
          position={stationPosition || defaultCoordinates}
          {...(onDragCoords ? { draggable: true, eventHandlers } : { })}
        >
          <Popup>
            {`[${stationIDX}] ${stationName}`}
          </Popup>
        </Marker>
        <MapCustomLayerControl defaultCollapsed />
        <ToStation
          coords={[lat, lng]}
        />
        <CustomZoomControll />
      </MapContainer>
    </div>
  );
}
export default MapProfileWidget;
